module.exports = __webpack_public_path__ + "static/media/mir-logo_original.12e3606b.svg";